import {
  addDays,
  differenceInCalendarDays,
  endOfDay,
  startOfDay,
} from 'date-fns';
import { Goal } from 'shared/types/goal';
import { TimelineTimeframes } from 'shared/types/timeline';
import { Timestamp } from 'shared/types/timestamp';

import { PLACEHOLDER_DURATIONS_DAYS } from './constants';
import { TimelineDropAnchors } from './types';

export type ComputeTimelineDropDatesOptions = {
  goal: Goal;
  dayIndex: number;
  rangeStartDate: Timestamp;
  timeframe: TimelineTimeframes;
  anchor: TimelineDropAnchors;
};

export const getTimelineDropDurationDays = (
  goal: Goal,
  timeframe: TimelineTimeframes,
): number => {
  if (!goal.startDate || !goal.deadline) {
    return PLACEHOLDER_DURATIONS_DAYS[timeframe];
  }
  return differenceInCalendarDays(goal.deadline, goal.startDate) + 1;
};

export const computeTimelineDropDates = ({
  goal,
  dayIndex,
  rangeStartDate,
  timeframe,
  anchor,
}: ComputeTimelineDropDatesOptions): {
  startDate: Timestamp;
  deadline: Timestamp;
} => {
  const durationDays = getTimelineDropDurationDays(goal, timeframe);
  const startDayIndex =
    anchor === TimelineDropAnchors.Centered
      ? dayIndex - Math.round(durationDays / 2)
      : dayIndex;
  const startDate = startOfDay(addDays(rangeStartDate, startDayIndex));
  const deadline = endOfDay(addDays(startDate, durationDays - 1));
  return { startDate, deadline };
};
